import Customer          from "../customer/Customer";
import Facility          from "../facility/Facility";
import Time              from "../fundamentals/date/Time";
import Staff             from "../staff/Staff";
import ReservationDetail from "./ReservationDetail";
import ReservationId     from "./ReservationId";

class Reservation {
  constructor(
    private readonly _id: ReservationId = new ReservationId(),
    private readonly _detail: ReservationDetail = new ReservationDetail(),
    private readonly _customer: Customer = new Customer(),
    private readonly _staff: Staff = new Staff(),
    private readonly _facility: Facility = new Facility(),
  ) {
  }

  public within(time: Time) {
    return this._detail.timePeriod.within(time);
  }

  get id() {
    return this._id;
  }

  get detail() {
    return this._detail;
  }

  get customer() {
    return this._customer;
  }

  get staff() {
    return this._staff;
  }

  get facility() {
    return this._facility;
  }
}

export default Reservation;
